import Playback from './Playback';
import resolvePlaybackActions from './resolvePlaybackActions';
import StoreName from '../Shared/Constants/StoreName';

const createPlaybackStore = state =>
    state.createStore({
        name: StoreName.PLAYBACK,
        model: Playback,
        actions: resolvePlaybackActions,
        emitOnSubscription: false,
    });

export default createPlaybackStore;
